module.exports = __webpack_public_path__ + "img/paperclip.ffa9eb67.svg";